import React, { useState, useEffect } from "react";
import EmailsList from "components/ShareDocuments/Emails/EmailsList";
import { getRandColor } from "components/ShareDocuments/Emails/emailRandomColor";
import "components/ShareDocuments/Emails/index.scss";
import {
  Wrapper,
  Title,
  ToWrapper,
  ContentMessage,
  IphoneMessege,
  Messege,
  Tags,
  TopPart,
  TagsWrapper,
  TagsScrollArea,
  Tag,
  Buttons,
  SaveAsDraft,
  Send,
  Previous,
  PushPreview,
  PushTitle,
  PushBody,
  PushLinkFields,
  PushLinkSectionTitle,
  PushLinkLabel,
  PushLinkInput,
  FieldSelector,
  CharacterCount,
  DynamicTextSection,
} from "./Theme";
import iphoneImage from "assets/icons/IphoneImage.png";
import { useDispatch, useSelector } from "react-redux";
import { default as FinanceSetting } from "Lib/API/FinanceSetting/FinanceSetting";
import { useAuth0 } from "@auth0/auth0-react";
import { toastr } from "react-redux-toastr";
import { setDataAfterCreatedCampaign } from "services/api/communication";
import { fromEtPickerDate } from "helper/dateFormat";
import CommunicationService from "Lib/API/Communication/index";
import CircularProgress from "@mui/material/CircularProgress";
import { setCardContent } from "services/api/communication";

export const SendTextMessege = ({ onBack, formik, setCardName, campaignType = "sms" }) => {
  const [savedEmails, setSavedEmails] = useState([]);
  const organization = JSON.parse(localStorage.getItem("organization"));
  const selectedAudiences = useSelector(
    (state) => state.communication.selectedAudienceRows
  );
  const { selectedTemplate, campaignEditData } = useSelector(
    (state) => state.communication
  );

  const { getAccessTokenSilently } = useAuth0();
  const [tokensList, setTokenList] = useState([]);
  const [textAreaContent, setTextAreaContent] = useState(
    campaignEditData?.message || ""
  );
  const [titleContent, setTitleContent] = useState(
    campaignEditData?.subject || ""
  );
  const [linkTitle, setLinkTitle] = useState(campaignEditData?.linkTitle || "");
  const [linkUrl, setLinkUrl] = useState(campaignEditData?.linkUrl || "");
  const [dynamicField, setDynamicField] = useState("title");
  const [createCampaignLoading, setCreateCampaignLoading] = useState(false);
  const [createCampaignDraftLoading, setCreateCampaignDraftLoading] =
    useState(false);
  const dispatch = useDispatch();
  const audienceRows =
    Object.keys(campaignEditData || {}).length > 0
      ? campaignEditData?.audience
      : selectedAudiences;
  const addEmailsHandler = ({ type, email }) => {
    if (savedEmails?.some((savedEmail) => savedEmail.email === email)) return;
    setSavedEmails((prev) => [
      ...prev,
      {
        type,
        email,
        image: email.charAt(0).toUpperCase(),
        color: getRandColor(),
      },
    ]);
  };
  useEffect(() => {
    const emails = [
      ...new Set((audienceRows || []).map((val) => val?.name).filter(Boolean)),
    ].map((item) => ({
      email: item,
      type: "to",
      image: item.charAt(0).toUpperCase(),
      color: getRandColor(),
    }));
    setSavedEmails(emails);
  }, [audienceRows]);
  const getTemplateTokens = async () => {
    const token = await getAccessTokenSilently();
    try {
      const response = await FinanceSetting.getTemplateTokens(
        token,
        "communication"
      );
      const tokens = response?.result;
      setTokenList(tokens);
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Something went wrong");
    }
  };
  useEffect(() => {
    getTemplateTokens();
  }, []);

  const handleDoubleClick = (tag) => {
    if (campaignType === "push" && dynamicField === "title") {
      if (`${titleContent}${tag}`.length > 30) {
        toastr.warning("Title limit", "This dynamic field does not fit in the title");
        return;
      }
      setTitleContent((previous) => `${previous}${tag}`);
      return;
    }
    if (campaignType === "push" && `${textAreaContent}${tag}`.length > 240) {
      toastr.warning("Body limit", "This dynamic field does not fit in the body");
      return;
    }
    setTextAreaContent((previous) => `${previous}${tag}`);
  };
  const handleTextAreaChange = (event) => {
    setTextAreaContent(event.target.value);
  };
  const createCampaign = async (isDraft) => {
    isDraft
      ? setCreateCampaignDraftLoading(true)
      : setCreateCampaignLoading(true);
    const token = await getAccessTokenSilently();
    const data = {
      isDraft: isDraft,
      data: {
        campaignName: formik.values?.campainName,
        campaignType,
        audience:
          Object.keys(campaignEditData)?.length > 0
            ? campaignEditData?.audience?.map((val) => val._id)
            : selectedAudiences?.map((val) => val._id),
        isScheduled: formik.values?.scheduledCampaign,
        subject: campaignType === "push" ? titleContent : formik.values?.subject,
        message: textAreaContent,
        ...(campaignType === "push" && {
          linkTitle,
          linkUrl,
        }),
        scheduled: {
          date: fromEtPickerDate(formik.values?.emailDate)?.toISOString() ?? null,
        },
      },
    };

    const finalData =
      Object.keys(campaignEditData).length > 0
        ? { id: campaignEditData?._id, ...data }
        : data;
    try {
      const response =
        Object.keys(campaignEditData).length > 0
          ? await CommunicationService.updateCampaign(finalData, token)
          : await CommunicationService.createCampaign(finalData, token);
      isDraft
        ? setCreateCampaignDraftLoading(false)
        : setCreateCampaignLoading(false);
      Object.keys(campaignEditData).length > 0
        ? toastr.success("Success", "Campaign updated sucessfully")
        : toastr.success("Success", "Campaign created sucessfully");
      dispatch(setDataAfterCreatedCampaign(response?.result));
      dispatch(setCardContent("Done"));
      setCardName(campaignType === "push" ? "PushNotification" : campaignType === "whatsapp" ? "WhatsApp" : "TextMessage");
    } catch (error) {
      toastr.error("Error", error?.data?.message ?? "Somthing Went Wrong");
      isDraft
        ? setCreateCampaignDraftLoading(false)
        : setCreateCampaignLoading(false);
    }
  };
  const isEmpty = textAreaContent === "" || (campaignType === "push" && titleContent === "");
  return (
    <Wrapper>
      <TopPart>
        <Title>{campaignType === "push" ? "Send Push Notification" : campaignType === "whatsapp" ? "Send WhatsApp Message" : "Send Text Message"}</Title>
        <ToWrapper>
          <span>To :</span>
          <EmailsList
            setSavedEmails={setSavedEmails}
            addEmailsHandler={addEmailsHandler}
            list={savedEmails}
            disabledAdding={true}
          />
        </ToWrapper>
      </TopPart>

      <ContentMessage>
        {campaignType === "push" ? (
          <IphoneMessege image={iphoneImage}>
            <span>{organization?.orgName}</span>
            <PushPreview>
              <div className="notification">
                <div className="notification-header">
                  <div className="app-icon">{organization?.orgName?.charAt(0) || "E"}</div>
                  <div className="notification-content">
                    <PushTitle
                      aria-label="Notification title"
                      data-active={dynamicField === "title"}
                      placeholder="Notification title"
                      maxLength={30}
                      value={titleContent}
                      onFocus={() => setDynamicField("title")}
                      onChange={(event) => setTitleContent(event.target.value)}
                    />
                    <CharacterCount>Max 30 characters</CharacterCount>
                  </div>
                </div>
                <PushBody
                  aria-label="Notification body"
                  data-active={dynamicField === "body"}
                  placeholder="Notification body"
                  maxLength={240}
                  value={textAreaContent}
                  onFocus={() => setDynamicField("body")}
                  onChange={handleTextAreaChange}
                />
                <CharacterCount>Max 240 characters</CharacterCount>
              </div>
            </PushPreview>
          </IphoneMessege>
        ) : (
          <IphoneMessege image={iphoneImage}>
            <span>{organization?.orgName}</span>
            <Messege
              placeholder="Add your text here"
              value={textAreaContent}
              onChange={handleTextAreaChange}
            />
          </IphoneMessege>
        )}
        <TagsWrapper>
          <TagsScrollArea>
          {campaignType === "push" && (
            <>
              <PushLinkSectionTitle>Link (optional)</PushLinkSectionTitle>
              <PushLinkFields>
                <PushLinkLabel>
                  Link label
                  <PushLinkInput
                    type="text"
                    placeholder="e.g. View details"
                    maxLength={50}
                    value={linkTitle}
                    onChange={(event) => setLinkTitle(event.target.value)}
                  />
                </PushLinkLabel>
                <PushLinkLabel>
                  Link URL
                  <PushLinkInput
                    type="text"
                    placeholder="https:// or {{link}}"
                    maxLength={2048}
                    value={linkUrl}
                    onChange={(event) => setLinkUrl(event.target.value)}
                  />
                </PushLinkLabel>
              </PushLinkFields>
            </>
          )}
          <DynamicTextSection>
            <span>Dynamic Text : </span>
            {campaignType === "push" && (
              <FieldSelector>
                <legend>Add dynamic text to:</legend>
                <label data-active={dynamicField === "title"}><input type="radio" name="dynamicField" value="title" checked={dynamicField === "title"} onChange={(event) => setDynamicField(event.target.value)} /> Title</label>
                <label data-active={dynamicField === "body"}><input type="radio" name="dynamicField" value="body" checked={dynamicField === "body"} onChange={(event) => setDynamicField(event.target.value)} /> Body</label>
              </FieldSelector>
            )}
            <span>Double click to add to the {campaignType === "push" ? dynamicField : "message"}</span>
            <Tags>
              {tokensList?.map((tag) => (
                <Tag type="button" key={tag?.value} onDoubleClick={() => handleDoubleClick(tag?.value)}>
                  {tag?.name}
                </Tag>
              ))}
            </Tags>
          </DynamicTextSection>
          </TagsScrollArea>
          <Buttons>
            <Previous onClick={onBack}>Previous</Previous>
            <>
              <SaveAsDraft
                onClick={() => createCampaign(true)}
                disabled={isEmpty}
                textAreaContent={isEmpty ? "" : textAreaContent}
              >
                {createCampaignDraftLoading ? (
                  <div className="d-flex justify-content-center w-100">
                    <CircularProgress
                      size={22}
                      style={{
                        color: "var(--Blues-Blue-Main, #2555EF)",
                      }}
                    />
                  </div>
                ) : (
                  "Save as a draft"
                )}
              </SaveAsDraft>
              <Send
                onClick={() => createCampaign(false)}
                disabled={isEmpty}
                textAreaContent={isEmpty ? "" : textAreaContent}
              >
                {createCampaignLoading ? (
                  <div className="d-flex justify-content-center w-100">
                    <CircularProgress size={22} style={{ color: "#ffffff" }} />
                  </div>
                ) : (
                  "Send"
                )}
              </Send>
            </>
          </Buttons>
        </TagsWrapper>
      </ContentMessage>
    </Wrapper>
  );
};
